'use client'

import React, { useState } from 'react'
import { faClose, faListUl } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { GOOGLE_REVIEW_LABELS } from '@/lib/utils/googleReview'
import '@/sass/menu/NavigationMenu.scss'

const SECTION_FALLBACK: Record<string, string> = {
  es: 'Sección', en: 'Section', fr: 'Section', ca: 'Secció', de: 'Abschnitt', eu: 'Atala'
}

interface Props {
  sectionList: {
    sectionName: string | undefined;
    sectionId: string;
    type?: string;
  }[]
  orderingActive: boolean
  language: string
}

const NavigationMenu = ({ sectionList, orderingActive, language }: Props) => {
  const [showMenu, setShowMenu] = useState(false)

  const handleNavigate = (sectionId: string) => {
    const element = document.getElementById(sectionId)
    if (element) {
      const stickyNav = document.querySelector('.carta-selector')
      const offset = stickyNav ? stickyNav.getBoundingClientRect().height : 0
      const top = element.getBoundingClientRect().top + window.scrollY - offset
      window.scrollTo({ top, behavior: 'smooth' })
    }
    setShowMenu(false)
  }

  const getLabel = (section: { sectionName?: string; type?: string }): string => {
    if (section.type === 'infoBlock') return 'Info'
    if (section.type === 'googleReview') return GOOGLE_REVIEW_LABELS[language as keyof typeof GOOGLE_REVIEW_LABELS] || 'Leave a review'
    return section.sectionName?.trim() || SECTION_FALLBACK[language] || 'Section'
  }

  return (
    <>
      {showMenu && (
        <div className='menu-overlay' onClick={() => setShowMenu(false)}>
          <article className='navigation-menu' onClick={(e) => e.stopPropagation()}>
            <ul>
              {sectionList.map((section, index) => {
                const displayName = getLabel(section)
                return (
                  <div key={index}>
                    <li onClick={() => handleNavigate(section.sectionId)}>
                      {displayName}
                    </li>
                    <hr />
                  </div>
                )
              })}
            </ul>
          </article>
        </div>
      )}

      <div className='navigation-menu-btn' style={orderingActive ? { bottom: '100px' } : {}} onClick={() => setShowMenu(!showMenu)}>
        <FontAwesomeIcon icon={showMenu ? faClose : faListUl} />
      </div>
    </>
  )
}

export default NavigationMenu
